import React from "react";
import 'antd/dist/reset.css';
import './App.css';
import './styling.css'
import {BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./Scenes/login/login";
import Register from "./Scenes/login/register";
import ForgotPassword from "./Scenes/login/ForgotPassword";
import ResetPassword from "./Scenes/login/ResetPassword";
import VerifyEmail from "./Scenes/login/VerifyEmail";
import PrivateRoute from "./PrivateRoute";
import ErrorPage from "./Scenes/erreur-page/ErrorPage";
import Clients from "./Scenes/clients/clients";
import MainLayout from "./Scenes/common/mainLayout";
import WithRoleProtection from "./WithRoleProtection";
import Criteres from "./Scenes/critères/criteres";
import Referentiel from "./Scenes/referentiel/referentiel";
// import ReviewPage from "./Scenes/stage-review/ReviewPage";
import DashboardVerdictia from "./Scenes/workspace/DashboardVerdictia";
import UserTablePage from "./Scenes/utilisateurs/userTablePage";
import StageReview from "./Scenes/stage-review/review-page/reviewPage";
import CineUploadOverlay from "./Scenes/stage-review/create/CineUploadOverlay";
import ArchimedeControlCenter from "./Scenes/archimede-control-center/ArchimedeControlCenter";
import ProductFeedbackDashboard from "./Scenes/product-feedback/ProductFeedbackDashboard";
import AdminCommercialControlPage from "./Scenes/admin/commercial/AdminCommercialControlPage";
import { PageTransitionProvider } from "./utils/pageTransition";
import BillingReturnPage from "./Scenes/billing/BillingReturnPage";

function App() {

    return (
        <Router>
            <PageTransitionProvider>
            <CineUploadOverlay />
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/verify-email" element={<VerifyEmail />} />

                <Route
                    path="/workspace"
                    element={
                        <PrivateRoute>
                            <WithRoleProtection path="/workspace">
                                <MainLayout />
                            </WithRoleProtection>
                        </PrivateRoute>
                    }
                >
                    <Route index element={<DashboardVerdictia />} />
                </Route>


                <Route
                    path="/clients"
                    element={
                        <PrivateRoute>
                            <WithRoleProtection path="/clients">
                                <MainLayout />
                            </WithRoleProtection>
                        </PrivateRoute>
                    }
                >
                    <Route index element={<Clients />} />
                </Route>

                <Route
                    path="/users"
                    element={
                        <PrivateRoute>
                            <WithRoleProtection path="/users">
                                <MainLayout />
                            </WithRoleProtection>
                        </PrivateRoute>
                    }
                >
                    <Route index element={<UserTablePage />} />
                </Route>

                <Route
                    path="/archimede-control-center"
                    element={
                        <PrivateRoute>
                            <WithRoleProtection path="/archimede-control-center">
                                <MainLayout />
                            </WithRoleProtection>
                        </PrivateRoute>
                    }
                >
                    <Route index element={<ArchimedeControlCenter />} />
                </Route>

                <Route
                    path="/admin/commercial"
                    element={
                        <PrivateRoute>
                            <WithRoleProtection path="/admin/commercial">
                                <MainLayout />
                            </WithRoleProtection>
                        </PrivateRoute>
                    }
                >
                    <Route index element={<AdminCommercialControlPage />} />
                </Route>

                <Route
                    path="/billing/success"
                    element={
                        <PrivateRoute>
                            <MainLayout />
                        </PrivateRoute>
                    }
                >
                    <Route index element={<BillingReturnPage variant="success" />} />
                </Route>

                <Route
                    path="/billing/cancel"
                    element={
                        <PrivateRoute>
                            <MainLayout />
                        </PrivateRoute>
                    }
                >
                    <Route index element={<BillingReturnPage variant="cancel" />} />
                </Route>

                <Route
                    path="/product-feedback"
                    element={
                        <PrivateRoute>
                            <WithRoleProtection path="/product-feedback">
                                <MainLayout />
                            </WithRoleProtection>
                        </PrivateRoute>
                    }
                >
                    <Route index element={<ProductFeedbackDashboard />} />
                </Route>

                <Route
                    path="/review-criteria"
                    element={
                        <PrivateRoute>
                            <WithRoleProtection path="/review-criteria">
                                <MainLayout />
                            </WithRoleProtection>
                        </PrivateRoute>
                    }
                >
                    <Route index element={<Criteres />} />
                </Route>

                <Route
                    path="/data"
                    element={
                        <PrivateRoute>
                            <WithRoleProtection path="/data">
                                <MainLayout />
                            </WithRoleProtection>
                        </PrivateRoute>
                    }
                >
                    <Route index element={<Referentiel />} />
                </Route>


                <Route
                    path="/stage-review/debug"
                    element={
                        <PrivateRoute>
                            <WithRoleProtection path="/stage-review">
                                <ErrorPage />
                            </WithRoleProtection>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/stage-review/:id_review"
                    element={
                        <PrivateRoute>
                            <WithRoleProtection path="/stage-review">
                                <StageReview  />
                            </WithRoleProtection>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/stage-review"
                    element={
                        <PrivateRoute>
                            <WithRoleProtection path="/stage-review">
                                <StageReview />
                            </WithRoleProtection>
                        </PrivateRoute>
                    }
                />

                <Route path="*" element={<ErrorPage />} />
            </Routes>
            </PageTransitionProvider>
        </Router>
    );
}

export default App;
